export function isDrawerMenuVisible(state) {
    return state.navigation.isDrawerMenuVisible;
}

export function getClients(state) {
    return state.tenants.data;
}